// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1iCEs","title":"Info_title__3vSEp","selects":"Info_selects__oUD7B","requiredAsterisk":"Info_requiredAsterisk__2OaLz"};